import React, { useEffect, useState } from "react";
import { Button, Input, Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const { TextArea } = Input;

export type NotificationModalProps = {
  open: boolean;
  vendorName?: string;
  onClose: () => void;
  onSend: (description: string) => void;
};

export const NotificationModal: React.FC<NotificationModalProps> = ({
  open,
  vendorName,
  onClose,
  onSend,
}) => {
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (!open) setDescription("");
  }, [open]);

  const handleSend = () => {
    onSend(description.trim());
    onClose();
  };

  return (
    <Modal
      title="Notification"
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={480}
      destroyOnClose
      className="notification-modal modal-round"
      closeIcon={<CloseOutlined className="notification-modal-close-icon" />}
    >
      <div className="notification-modal-body">
        <TextArea
          placeholder="Add Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={6}
          className="notification-modal-textarea"
          autoSize={{ minRows: 6, maxRows: 10 }}
        />
        <Button
          type="primary"
          size="large"
          className="notification-modal-send-btn"
          onClick={handleSend}
        >
          Send
        </Button>
      </div>
    </Modal>
  );
};

export default NotificationModal;
